
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

interface VerificationMessageProps {
  onClose: () => void;
  isModal?: boolean;
  email?: string;
  isAlreadySubscribed?: boolean;
}

export function VerificationMessage({ 
  onClose, 
  isModal = false,
  email,
  isAlreadySubscribed = false
}: VerificationMessageProps) {
  return (
    <div className="text-center">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
        <Check className="h-6 w-6 text-green-600" />
      </div>
      
      <h3 className="mt-4 text-lg font-semibold">
        {isAlreadySubscribed 
          ? "Vous êtes déjà inscrit !" 
          : "Email de vérification envoyé !"}
      </h3>
      
      <div className="mt-2 space-y-2">
        {isAlreadySubscribed ? (
          <p className="text-sm text-gray-500">
            L'adresse {email} est déjà inscrite à notre newsletter.
          </p>
        ) : (
          <>
            <p className="text-sm text-gray-500">
              Nous avons envoyé un email de vérification à l'adresse :
            </p>
            <p className="text-sm font-medium">{email}</p>
            <p className="text-sm text-gray-500">
              Veuillez vérifier votre boîte de réception et cliquer sur le lien de confirmation pour finaliser votre inscription.
            </p>
          </>
        )}
      </div>
      
      <Button 
        onClick={onClose} 
        className={`mt-5 ${isModal ? 'bg-[#00123A] hover:bg-[#00123A]/90' : ''}`}
      >
        Fermer
      </Button>
    </div>
  );
}
